'use strict';

import Component from 'generic.basecomponent';

export default class FileInput extends Component {
    constructor(el) {
        super(el);
        this.captionContainerSelector = '.js-file-input-caption';
        this.defaultCaption = 'No file chosen';
        this.init();
    }

    init() {
        this.fileControl = this.container.querySelector('input[type="file"]');
        this.captionContainer = this.container.querySelector(this.captionContainerSelector);
        if (!this.fileControl || !this.captionContainer) {
            return;
        }

        this.fileControl.setAttribute('style', `
         width: 0.1px;
         height: 0.1px;
         opacity: 0;
         overflow: hidden;
         position: absolute;
         z-index: -1;
         `);

        this.caption = document.createElement('span');
        this.captionContainer.appendChild(this.caption);


        this.fileControl.addEventListener('change', this.onFileChange.bind(this));
        this.updateCaption();
    }

    onFileChange(e) {
        this.updateCaption();
    }

    updateCaption() {
        let caption = '';
        if (this.fileControl.files && this.fileControl.files.length > 1) {
            caption = `${this.fileControl.files.length} files selected`;
        } else {
            caption = this.fileControl.value.split('\\').pop();
        }
        if (caption) {
            this.caption.innerHTML = caption;
        } else {
            this.caption.innerHTML = this.defaultCaption;
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/file-input/js/generic.file-input.js